export default __webpack_public_path__ + "static/media/transfer-send-step7.690a362a.png";